import axios from "../../axios";
import { getErrorMessage } from "../../helpers/ErrorMessage";
import { login, logout } from "../../utils/auth";
import { AUTH_ERROR, AUTH_LOGIN, AUTH_LOGOUT } from "../types";
import Swal from "sweetalert2";

export const authLogin = (data, history) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: "Bearer essential",
      },
    };

    const res = await axios.post("admin/login", data, config);

    // CRITICAL: Check if OTP is required FIRST
    if (res.data.code === 1 && res.data.message === "OTP Sent to your mobile") {
      return res.data;
    }

    // If login is successful (with token)
    if (res.data.code === 1 && res.data.access_token) {

      let user = {
        access_token: res.data.access_token,
        refresh_token: res.data.refresh_token,
      };

      login(user);
      dispatch({ type: AUTH_LOGIN, payload: user });

      Swal.fire({
        title: "Success!",
        text: "Login successful!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      // Return success response
      return {
        success: true,
        status: "Success",
        ...res.data,
      };
    }

    // If login failed with code 0
    if (res.data.code === 0) {

      dispatch({ type: AUTH_ERROR, payload: res.data.data.message });

      Swal.fire({
        title: "Login Failed",
        text: res.data.data.message,
        icon: "warning",
      });

      // Return error response
      return {
        success: false,
        code: 0,
        message: res.data.data.message,
      };
    }

    // For any other response
    Swal.fire({
      title: "Error",
      text: "Received an invalid response from the server.",
      icon: "error",
    });

    return {
      success: false,
      message: "Invalid response from server",
    };
  } catch (err) {
    dispatch({ type: AUTH_ERROR, payload: err.message });

    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
    });

    // Return error response
    return {
      success: false,
      error: true,
      message: errorMessage,
    };
  }
};

// User Logout
export const authLogout = () => async (dispatch) => {
  try {
    logout();
    dispatch({ type: AUTH_LOGOUT, payload: "" });
    // dispatch(setAlert('Logout done', 'success'));
  } catch (err) {
    dispatch({ type: AUTH_ERROR, payload: err.message });
    // dispatch(setAlert(err.message, 'danger'));
  }
};
